export var PresenceStatus;
(function (PresenceStatus) {
    PresenceStatus[PresenceStatus["EDITING"] = 10] = "EDITING";
    PresenceStatus[PresenceStatus["ONLINE"] = 100] = "ONLINE";
    PresenceStatus[PresenceStatus["AWAY"] = 110] = "AWAY";
    PresenceStatus[PresenceStatus["OFFLINE"] = 120] = "OFFLINE";
    PresenceStatus[PresenceStatus["TALKING"] = 130] = "TALKING";
})(PresenceStatus || (PresenceStatus = {}));
;
//# sourceMappingURL=presence-status.enum.js.map